import { UntypedFormGroup } from '@angular/forms';
import { ScopeTemplate } from '../interfaces/scope-template';
import { BaseModel } from './base.model';

export class ScopeTemplateModel extends BaseModel implements ScopeTemplate {
	public title: string;
	public type: string;
	public isActive: boolean;
	public message: string;
	public company: string;
	public order: number;

	constructor(json?: any) {
		super();
		if (json) {
			this.deserialize(json);
		}
		this.formGroup = this.createForm();
	}

	public createForm(): UntypedFormGroup {
		return new UntypedFormGroup({});
	}

	getFormData(): FormData {
		return undefined;
	}
}
